import { useState } from "react";
import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useGiftData } from "../../../lib/useMockData";

export default function FAQSection() {
  const { faqData } = useGiftData();
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-2">{faqData.label}</p>
              <h2 className="section-title">{faqData.title}</h2>
            </div>
          </ScrollReveal>

          <div className="space-y-3">
            {faqData.questions.map((q, idx) => (
              <ScrollReveal key={idx} direction="up" delay={idx * 60}>
                <div className="bg-white rounded-lg border border-airdoa-gray-light/30 overflow-hidden">
                  <button
                    onClick={() =>
                      setOpenIdx(openIdx === idx ? null : idx)
                    }
                    className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left hover:bg-airdoa-cream/50 transition-colors"
                  >
                    <span className="flex items-center gap-3">
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-airdoa-gold/20 text-airdoa-gold text-xs font-bold shrink-0">
                        Q
                      </span>
                      <span className="text-sm font-medium text-airdoa-navy leading-snug">
                        {q.q}
                      </span>
                    </span>
                    <span className="w-5 h-5 flex items-center justify-center text-airdoa-gray shrink-0 transition-transform duration-300">
                      <i
                        className={`ri-arrow-down-s-line ${
                          openIdx === idx ? "rotate-180" : ""
                        }`}
                      />
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      openIdx === idx
                        ? "max-h-60 opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="px-5 pb-5 md:px-6 md:pb-6 flex items-start gap-3">
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-airdoa-navy/10 text-airdoa-navy text-xs font-bold shrink-0">
                        A
                      </span>
                      <p className="text-sm text-airdoa-gray leading-relaxed">
                        {q.a}
                      </p>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}